const features = [
  {
    icon: 'ri-refresh-line',
    title: 'Easy Conversion',
    description: 'All our sofa beds convert in under 30 seconds — no tools, no fuss. From sofa to bed and back effortlessly.',
  },
  {
    icon: 'ri-moon-line',
    title: 'Sleep-Grade Comfort',
    description: 'We only carry sofa beds with certified foam or innerspring mattresses rated for nightly use — not just occasional guests.',
  },
  {
    icon: 'ri-layout-2-line',
    title: 'Space-Smart Design',
    description: 'Engineered for modern living — our designs maximize comfort without sacrificing floor space in any room size.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Free US Delivery',
    description: 'Every order ships free to your door across the United States. White-glove setup available in Phoenix, AZ.',
  },
];

export default function WhyUs() {
  return (
    <section className="w-full bg-white py-24 px-6 md:px-16">
      {/* Header */}
      <div className="text-center mb-16">
        <p className="text-xs uppercase tracking-[0.3em] text-[#8B6348] mb-3 font-medium">Our Promise</p>
        <h2 className="text-4xl md:text-5xl font-bold text-[#2c2420]" style={{ fontFamily: "'Playfair Display', serif" }}>
          Why SWIFTMARKET
        </h2>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className="bg-[#faf8f5] rounded-2xl p-8 flex flex-col gap-5 hover:-translate-y-1 transition-transform duration-300"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#f0e6d8]">
              <i className={`${f.icon} text-2xl text-[#8B6348]`} />
            </div>
            <div>
              <h3 className="text-[#2c2420] font-semibold text-base mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                {f.title}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">{f.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
